import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Grid,
  List,
  ListItem,
  ListItemText,
  Chip,
  useTheme,
  Box,
} from '@mui/material';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

const ClinicSetting = ({ data }) => {
  const theme = useTheme();

  if (!data) return null;

  const renderBool = (val) =>
    val ? (
      <Chip
        label="Yes"
        size="small"
        color="success"
        icon={<CheckCircleIcon />}
        sx={{
          fontSize: theme.typography.small.fontSize,
          fontWeight: theme.typography.small.fontWeight,
        }}
      />
    ) : (
      <Chip
        label="No"
        size="small"
        color="error"
        icon={<HighlightOffIcon />}
        sx={{
          fontSize: theme.typography.small.fontSize,
          fontWeight: theme.typography.small.fontWeight,
        }}
      />
    );

  const renderText = (text) => (
    <Typography
      variant="smallRegular"
      sx={{ color: theme.palette.text.secondary }}
    >
      {text}
    </Typography>
  );

  return (
    <Card
      elevation={3}
      sx={{
        backgroundColor: theme.palette.gery.white,
        boxShadow: theme.shadows[1],
        mb: 4,
      }}
    >
      <CardContent>
        <Box display="flex" alignItems="center" mb={2}>
          <MedicalServicesIcon
            fontSize="small"
            sx={{ mr: 1, color: theme.palette.action.purpleLight }}
          />
          <Typography variant="h3" color="text.primary">
            Clinic Settings
          </Typography>
        </Box>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <List dense disablePadding>
              <ListItem disableGutters>
                <ListItemText
                  primary="Established In"
                  secondary={renderText(data.establishmentYear || 'N/A')}
                />
              </ListItem>
              <ListItem disableGutters>
                <ListItemText
                  primary="Accepting Tokens"
                  secondary={renderText(
                    data.acceptingTokens === 'yes' ? 'Yes' : 'No'
                  )}
                />
              </ListItem>
              <ListItem disableGutters>
                <ListItemText
                  primary="Patient Review Allowed"
                  secondary={renderBool(data.acceptingPatientReview)}
                />
              </ListItem>
              <ListItem disableGutters>
                <ListItemText
                  primary="Booking Window (days)"
                  secondary={renderText(
                    data.appointmentBookingWindow || 'N/A'
                  )}
                />
              </ListItem>
              <ListItem disableGutters>
                <ListItemText
                  primary="Minimum Prior Time (mins)"
                  secondary={renderText(
                    data.minimumPriorBookingTime || '0'
                  )}
                />
              </ListItem>
            </List>
          </Grid>

          <Grid item xs={12} sm={6}>
            <List dense disablePadding>
              <ListItem disableGutters>
                <ListItemText
                  primary="Consulting Fees (New Case)"
                  secondary={renderText(
                    data.consultingFees ? `₹${data.consultingFees}` : 'N/A'
                  )}
                />
              </ListItem>
              <ListItem disableGutters>
                <ListItemText
                  primary="Consulting Fees (Old Case)"
                  secondary={renderText(
                    data.oldCaseConsultingFees
                      ? `₹${data.oldCaseConsultingFees}`
                      : 'N/A'
                  )}
                />
              </ListItem>
              <ListItem disableGutters>
                <ListItemText
                  primary="Emergency Fees"
                  secondary={renderText(
                    data.emergencyFees ? `₹${data.emergencyFees}` : 'N/A'
                  )}
                />
              </ListItem>
              <ListItem disableGutters>
                <ListItemText
                  primary="Case Validity (days)"
                  secondary={renderText(data.caseValidityDays || 'N/A')}
                />
              </ListItem>
            </List>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default ClinicSetting;
